import { useState } from 'react';
import './HamburgerMenu.css';

export default function HamburgerMenu() {
  const [open, setOpen] = useState(false);

  const goToSection = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) 
      {
      el.scrollIntoView({ behavior: "smooth" });
      }
  };

  const goToDistrito = (distrito) => {
    setOpen(false);
    window.open(`/catalogo?distrito=${distrito}`, "_blank");
  };

  return (
    <>
      {/* Botón hamburguesa */}
      <button
        className={`hamburger-btn ${open ? "open" : ""}`}
        onClick={() => setOpen(!open)}
      >
        <span />
        <span />
        <span />
      </button>

      {/* Menú lateral */}
      <aside className={`hamburger-menu ${open ? "open" : ""}`}>
        <div className="menu-scroll">

          {/* SECCIÓN 1 */}
          <div className="menu-section">
            <button onClick={() => goToSection("top")}>Página principal</button>
            <button onClick={() => window.open("/catalogo", "_blank")}>Novias</button>
            <button onClick={() => goToSection("ranking")}>Ranking</button>
            <button onClick={() => goToSection("distritos")}>Novias por distrito</button>
            <button onClick={() => goToSection("about")}>¿Qué es una novia de alquiler?</button>
            <button onClick={() => goToSection("faq")}>Preguntas Frecuentes</button>
            <button onClick={() => goToSection("categories")}>Presentaciones por tipo</button>
            <button onClick={() => goToSection("review")}>Reseñas</button>
          </div>

          <hr />

          {/* SECCIÓN 2 */}
          <div className="menu-section">
            <div className="menu-title">Ubicaciones</div>
            <div className="menu-subtitle">Lista de distritos</div>

            {[
              "Miraflores",
              "San Isidro",
              "Barranco",
              "Surco",
              "La Molina",
              "San Borja",
              "Chorrillos",
              "Magdalena",
              "Lince",
              "Jesús María"
            ].map((d) => (
              <button key={d} onClick={() => goToDistrito(d)}>
                {d}
              </button>
            ))}
          </div>

        </div>
      </aside>

      {/* Overlay */}
      {open && <div className="menu-overlay" onClick={() => setOpen(false)} />}
    </>
  );
}